export default {
  templateTab: {
    TemplateLibrary: 'Template Library',
    myTemplate: 'My Templates',
  },
  description: 'Description',
  name: 'Name',
  save: 'Save',
  cancel: 'Cancel',
  saveChartLayout: 'Save Chart Layout',
  nameIsRequired: 'Name is required',
  loadTemplate: 'Load Template',
  saveTemplate: 'Save Template',
  copyToClipboard: 'Copy to clipboard',
  shareChartLayout: 'Share chart layout',
  copy: 'Copy',
  share: 'Share',
  deleteTemplate: 'Delete Template',
  noTemplate: 'No Template',
  search: 'Search',

  revenue: 'Revenue: %{value}',
  profit: 'Profit: %{value}',
  periodEnding: 'Period Ending: %{value}',

  dividends: 'Dividends: %{value}',
  exRatio: 'Ex Ratio: %{value} %',
  exrightDate: 'Ex right Date: %{value}',
  planVolume: 'Plan volume: %{value}',

  issueMethod: 'Issue Method: %{value}',
  exIssueDate: 'Ex Issue Date: %{value}',

  traderName: 'Name: %{value}',
  buy: 'Bought: %{value}',
  sell: 'Sold: %{value}',
  volume: 'Volume: %{value}',
  confirmDelete: 'Are you sure ?',

  buyRegister: 'Register buying : %{value}',
  sellRegister: 'Register selling : %{value}',
  buyNotHappen: 'Register Buy %{value}',
  buyNotHappenStatus: 'Status: Fail',
  sellNotHappen: 'Register Sell %{value}',
  sellNotHappenStatus: 'Status: Fail',
};
